import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

//components base of every page
import HeaderAll from './components/headerAll.js';
import FooterAll from './components/footerAll.js';



import Slideshow from './components/slideshow.js';
//file screens for routering
import Who from './screens/who.js';
import Where from './screens/where.js';
import When from './screens/when.js';
import Contact from './screens/contact.js';

import Support from './supportBotanicaUrbanaSenago.js';

import GrowShop from './screens/grow.js';
import CannabisLight from './screens/cannabis.js';
import SmokerArticle from './screens/article.js';
import Talee from './screens/talee.js';


//buttons connect to screens
import buttonWho from './assets/buttonProduct_who.png';
import buttonWhere from './assets/buttonProduct_where.png';
import buttonWhen from './assets/buttonProduct_when.png';
import buttonContact from './assets/buttonProduct_contact.png';

import buttonArticle from './assets/buttonProduct_article.png';
import buttonTalee from './assets/buttonProduct_talee.png';
import buttonGrow from './assets/buttonProduct_grow.png';
import buttonCannabis from './assets/buttonProduct_cannabis.png';



//image for Slideshow


import './App.css';

class App extends Component {

  Scroll() {
    window.scrollBy(0, 250);
  }


  render() {
    return (
      <div className="App">

        <HeaderAll />


          <Router>
            <div className="menuPrinc">
              <div className="insideButton">
                <ul>
                  <li><div className="buttonInfo"><Link to="/who"><img src={buttonWho} alt="Pagina info" width="100%" /></Link></div></li>
                  <li><div className="buttonInfo"><Link to="/where"><img src={buttonWhere} alt="Pagina info" width="100%" /></Link></div></li>
                  <li><div className="buttonInfo"><Link to="/when"><img src={buttonWhen} alt="Pagina info" width="100%" /></Link></div></li>
                  <li><div className="buttonInfo"><Link to="/contact"><img src={buttonContact} alt="Pagina info" width="100%" /></Link></div></li>
                </ul>
              </div>

              <Route exact path="/who" component={Who} />
              <Route exact path="/where" component={Where} />
              <Route exact path="/when" component={When} />
              <Route exact path="/contact" component={Contact} />
              <Route exact path="/support" render={() => <Support />} />
            </div>
          </Router>

          <div className="desc-app">
            <h1>Botanica Urbana , Senago </h1>
            <h3> Offriamo un’ampia varietà di prodotti per la coltivazione, vendita di articoli per fumatori, Cannabis Light e talee.
            <br />
            <br /> Nella sezione Contatti troverai la nostra chat privata, <br />saremo lieti di rispondere alle tue domande !</h3>
          </div>


          <Slideshow />
          <Router>


            <div className="pagesProduct">

            <div className="desc-app">
              <h3>Scopri qui i nostri prodotti</h3>
            </div>

              <div className="buttonProduct"><Link to="/grow" onClick={this.Scroll}><img className="" src={buttonGrow} alt="Prodotto venduto da Botanica Urbana Senago" width="75%" /></Link></div>
              <div className="buttonProduct"><Link to="/cannabis" onClick={this.Scroll}><img className="" src={buttonCannabis} alt="Prodotto venduto da Botanica Urbana Senago" width="75%" /></Link></div>
              <div className="buttonProduct"><Link to="/article" onClick={this.Scroll}><img className="" src={buttonArticle} alt="Prodotto venduto da Botanica Urbana Senago" width="75%" /></Link></div>
              <div className="buttonProduct"><Link to="/talee" onClick={this.Scroll}><img className="" src={buttonTalee} alt="Prodotto venduto da Botanica Urbana Senago" width="75%" /></Link></div>

              <Route path="/grow" component={GrowShop}/>
              <Route path="/cannabis" component={CannabisLight} />
              <Route path="/article" component={SmokerArticle} />
              <Route path="/talee" component={Talee} />
            </div>
          </Router>
        <FooterAll />
      </div>
    );
  }
}

export default App;
